import averageIntensity from "./data/average-intensities.min.js";
import marginalIntensity from "./data/marginal-intensities-2021.min.js";

export { averageIntensity, marginalIntensity };
export default { averageIntensity, marginalIntensity };
